var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-wrapper',[_c('com-banner'),_c('com-team'),_c('com-services'),_c('app-quotes'),_c('com-news')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }